var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalogSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Analogue_Small") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164,124.38c0-18.59,10.77-19.38,13.49-19.38H190",
    fill: "none",
    stroke: "#898989",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10,105H22.21s13.35-.74,13.35-12.46V61.25c0-24.9,32.54-25.51,32.54,0v82.24c0,24.36,29.88,24.36,29.88,0V33.84c0-24.79,32.65-24.79,32.65,0V166.43c0,25.19,32.84,24.58,32.84.86V127.44",
    fill: "none",
    stroke: "#898989",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalogSmall);
export default __webpack_public_path__ + "static/media/Analog_Small.228f86265f25ced81ba12e93b9c5c01a.svg";
export { ForwardRef as ReactComponent };